import { Component, inject } from '@angular/core';
import { IrisDMSFileI } from '@iris/common/modules/dms/models/IrisDMSFile';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastService } from '@ngx-strakit/cdk/controls/toast';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { UpperCasePipe } from '@angular/common';
import { IrisCopyFieldComponent } from '@iris/common/modules/copy-field/copy-field.component';
import { IrisFileShareLinkExternalComponent } from './file-share-link-external/file-share-link-external.component';
import { FormsModule } from '@angular/forms';
import { IrisDmsRoutingService } from '../../../services/dms-routing.service';
import { SkRadioMode, StrakitRadioInputComponent } from '@ngx-strakit/cdk/controls';
import { SkModalBase, SkModalContentComponent } from '@ngx-strakit/cdk';

export enum ShareType {
  Internal,
  External,
}

@Component({
  selector: 'iris-dms-file-share-link-modal',
  imports: [
    FormsModule,
    TranslatePipe,
    UpperCasePipe,
    StrakitRadioInputComponent,
    SkModalContentComponent,

    IrisCopyFieldComponent,
    IrisFileShareLinkExternalComponent,
  ],
  templateUrl: './file-share-link-modal.component.html',
  styleUrls: ['./file-share-link-modal.component.scss'],
})
export class IrisDmsFileShareLinkModalComponent extends SkModalBase<IrisDmsFileShareLinkModalComponent, void> {
  protected readonly translateService = inject(TranslateService);
  private readonly dmsRoutingService = inject(IrisDmsRoutingService);
  private readonly toastService = inject(ToastService);

  readonly file = inject<{ file: IrisDMSFileI }>(MAT_DIALOG_DATA).file;
  shareView: ShareType = ShareType.Internal;

  readonly permanentLinkMode = SkRadioMode.TextAndIcon;
  readonly shareViewOptions = [
    {
      value: ShareType.Internal,
      title: this.translateService.instant('label.AccessibleOnlyForIrisUsers'),
    },
    {
      value: ShareType.External,
      title: this.translateService.instant('label.AccessibleForExternalUser'),
    },
  ];

  get isShareViewInternal(): boolean {
    return this.shareView === ShareType.Internal;
  }

  get isShareViewExternal(): boolean {
    return this.shareView === ShareType.External;
  }

  get internalLink(): string {
    return this.dmsRoutingService.getFileInternalLink(this.file?.id);
  }

  onCopyLink(): void {
    this.toastService.success({ message: this.translateService.instant('text.dms.FileShareLinkCopied') });
  }
}
